import { SmileClipboardIllustration } from '@hg/stylizator/illustrations'
import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'

import { IWPGBlockAttributesCompare } from 'app/helpers/IWPGBlockAttributesCompare'

const SmileClipboardIllustrationBlock: React.FC<IWPGBlock> = () => <SmileClipboardIllustration />

export default React.memo(SmileClipboardIllustrationBlock, IWPGBlockAttributesCompare)
